import React from 'react';
import { Box, BoxProps } from '@apia/theme';
import TabsController from './tabsController';
import { TabsContext } from './util';
import { useMount } from '@apia/util';
import { TTab, TabsControllerProps } from './types';

const NonForwardedTabs = (
  {
    id,
    getController,
    initialTabs,
    orientation,
    ...props
  }: TabsControllerProps<TTab> & Omit<BoxProps, 'id' | 'as' | 'role'>,
  ref: React.ForwardedRef<HTMLDivElement>,
) => {
  const [handler, setHandler] = React.useState<TabsController | null>(null);

  useMount(() => {
    const newHandler = new TabsController(String(id), {
      initialTabs,
      orientation: orientation || 'horizontal',
    });
    setHandler(newHandler);
    getController?.(newHandler);
  });

  if (!handler) return null;

  return (
    <TabsContext.Provider value={handler}>
      <Box
        {...props}
        onKeyDown={(ev: React.KeyboardEvent<HTMLDivElement>) => {
          handler.handleKeyDown(ev);
        }}
        ref={ref}
      />
    </TabsContext.Provider>
  );
};

export const Tabs = React.forwardRef<
  HTMLDivElement,
  TabsControllerProps<TTab> & Omit<BoxProps, 'id' | 'as' | 'role'>
>(NonForwardedTabs) as unknown as typeof NonForwardedTabs;
